// event_type -> {label, icon} for the Journey page's Activity tab.
// icon names match lucide-react component names; ActivityTimeline looks
// them up from there. Falls back to humanizing the raw key for any
// event_type not listed here, so a new writer never breaks the timeline.
export const GROUP_EVENT_LABELS = {
  group_created: { label: "WhatsApp group created", icon: "Users" },
  wa_group_deleted: { label: "WhatsApp group deleted", icon: "Trash2" },
  participant_added: { label: "Member joined", icon: "UserPlus" },
  participant_removed: { label: "Member left", icon: "UserMinus" },
  invite_sent: { label: "Invite sent", icon: "Send" },
  template_sent: { label: "Message sent", icon: "MessageSquare" },
  media_sent: { label: "Media sent", icon: "Image" },
  staff_message: { label: "Staff reply", icon: "MessageCircle" },
  customer_message: { label: "Customer message", icon: "MessageCircle" },
  document_sent: { label: "Document uploaded", icon: "FileText" },
  group_updated: { label: "Group updated", icon: "Pencil" },
  job_card_sent: { label: "Job card sent", icon: "ClipboardList" },
  pre_delivery_feedback_sent: { label: "Pre-delivery feedback sent", icon: "MessageSquare" },
  post_delivery_feedback_sent: { label: "Post-delivery feedback sent", icon: "MessageSquare" },
  vehicle_delivered: { label: "Vehicle delivered", icon: "PackageCheck" },
  sla_rung_fired: { label: "Escalation reminder sent", icon: "AlarmClock" },
  complaint_confirmation_received: { label: "Complaint confirmation reply", icon: "MessageCircleQuestion" },
  complaint_registered: { label: "Complaint registered", icon: "ClipboardCheck" },
  staff_message_blocked: { label: "Staff message blocked (not polite)", icon: "ShieldAlert" },
};

function humanize(eventType) {
  return String(eventType || "")
    .split("_")
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");
}

export function labelForEvent(eventType) {
  return GROUP_EVENT_LABELS[eventType] || { label: humanize(eventType), icon: "Circle" };
}

// message_log.stage -> the Service Journey stage label shown on an
// "Automated" chat card (apps/web/src/components/chat/MessageBubble.jsx),
// so an Estimate document and a Job Card document don't both just read as
// "a document". Keyed by the same stage strings every automated-send logger
// writes (wa_worker._log_group_send, server.py's _log_outbound,
// post_delivery_feedback_message, and the webhook's own senders).
export const STAGE_LABELS = {
  media: "Inspection Media",
  delivery_media: "Delivery Media",
  estimate: "Estimate",
  job_card: "Job Card",
  work_progress: "Work Progress",
  parts_approval: "Parts Approval",
  pre_invoice: "Pre Invoice",
  invoice: "Invoice",
  final_bill: "Final Bill",
  pre_delivery_feedback: "Pre Delivery Feedback",
  feedback_cia: "Feedback Request",
  post_delivery_feedback: "Post Delivery Feedback",
  app_download: "App Download",
  workshop_contacts: "Escalation Metrics",
  welcome: "Welcome Message",
  next_service_due: "Next Service Due",
  feedback_nps: "Feedback (NPS)",
  post_delivery_custom_message: "Post Delivery Message",
  cta_response: "Auto Reply",
  complaint_registered: "Complaint Registered",
};

export function labelForStage(stage) {
  return STAGE_LABELS[stage] || (stage ? humanize(stage) : "");
}
